import request from '@/utils/request';

// 打点
const doPoint = (key, segmentation) => {
  return request({
    method: 'POST',
    url: '/stat/h5/event_analyse/data_upload/',
    data: {
      events: JSON.stringify([
        {
          key,
          segmentation,
        },
      ]),
    },
  });
};

export default doPoint;
